// Vue-komponent <eui-burgare>
//
// Registrering i app (här exemplifierat med en komponent 'komp'):
//
// import komp from 'kompFile';
// Vue.use(komp);											// Registrera globalt (som plugin).
//
//	 -eller-
// components: {
//		[komp.component.name]: komp.component,		// Registrera lokalt.
//
//	 -eller-
// components: {
//		'eget-tagnamn': komp.component,				// Registrera lokalt, med eget custom tagnamn.

import { euiGeneriskKryssrutaMixin } from 'v-mixins/euiGeneriskKryssrutaMixin';
import euiModifieradSvg from 'v-components/euiModifieradSvg';
//import { SvgikonBurgare, SvgikonBurgarePunkter, SvgikonStang } from 'Svgikoner';


// Finns i mixin ist:
//// Gemensam för alla sådana här komponenter på en sida, vilket är precis det vi vill:
//let uniktIdCounter = 0;


//###################################################################################################

export default {

	// Själva komponenten, för användning vid lokal registrering (se anvisningar ovan):
	component: {

		name: 'eui-burgare',

		// Padding på label nedan är för att ge en större klick-/touchyta:
		// @click.stop.prevent hindrar webbläsarens egna toggling, vilket förhindrar att den får en fokusring vid just klick (den ska få det vid tabbning): 
		template: `
			<div
				class="_eui-burgare"
				:class="{
					['-ikon-av-' + vpIkonAv]:vpIkonAv,
					['-ikon-pa-' + vpIkonPa]:vpIkonPa,
					'-med-etikett':harText,
					'-etikett-till-hoger':harText && vpEtikettTillHoger,
					'-etikett-till-vanster':harText && !vpEtikettTillHoger,
					'-paslagen':vpPaslagen,
					'-inaktiverad':skaVaraInaktiverad,
					'-osynlig':skaVaraOsynlig
				}"
				:disabled="skaVaraInaktiverad"
			>
				<input :id="uniktId" :checked="vpPaslagen" @change="onChange" :disabled="skaVaraInaktiverad" type="checkbox" :title="vpTooltip">
				<label :for="uniktId"
					:title="vpTooltip"
					@click.stop.prevent="onChange"
				>

					<span v-if="harText && !vpEtikettTillHoger"
						class="_eui-burgare_etikett"
						:style="{ 'font-size':vpTextStorlek }"
					>
						<slot></slot>
					</span>



					<!--<transition name="el-zoom-in-top">-->

						<span v-if="vpPaslagen" key="for-transition--pa"
							class="_eui-burgare_box"
							:style="{
								width:ikonPaStorlek,
								height:ikonPaStorlek,
								border: borderWidthValueAndUnit + ' solid transparent'
							}"
						>
							<eui-modifierad-svg
								:vp-ikon="vpIkonPa"
							></eui-modifierad-svg>
						</span>

						<span v-else key="for-transition--av"
							class="_eui-burgare_box"
							:style="{
								width:vpIkonAvStorlek,
								height:vpIkonAvStorlek,
								border: borderWidthValueAndUnit + ' solid transparent'
							}"
						>
							<eui-modifierad-svg
								:vp-ikon="vpIkonAv"
							></eui-modifierad-svg>
						</span>

					<!--</transition>-->



					<span v-if="harText && vpEtikettTillHoger"
						class="_eui-burgare_etikett"
						:style="{ 'font-size':vpTextStorlek }"
					>
						<slot></slot>
					</span>

				</label>
			</div>
		`,

		// All generisk kryssrutefunktionalitet, se 'euiGeneriskKryssrutaMixin.js'.
		// Props:		vpPaslagen, vpInaktiverad, vpOsynlig, vpTooltip, vpAccessKey
		// Data:			uniktId, mixinIsMounted, mixinIsMountedAndNextTick, mixinIsMountedAndSecondNextTick
		// Computed:	skaVaraOsynlig, skaVaraInaktiverad
		// Events:	andrad
		// Model:	vpPaslagen, andrad
		mixins: [euiGeneriskKryssrutaMixin],

		components: {
			euiModifieradSvg,
		},

		// Props utöver de från mixin ovan:
		props: {
			vpIkonAv: {
				type: String,
				default: 'burgarePunkter',
			},
			vpIkonAvStorlek: {
				type: String,
				default: '1.7rem',
			},

			vpIkonPa: {
				type: String,
				default: 'stang',
			},
			vpIkonPaStorlek: {
				type: String,
				default: undefined,		// undefined => samma storlek som vpIkonAvStorlek
			},

			vpTextStorlek: {
				type: String,
				default: '1em',
			},
			vpEtikettTillHoger: {
				type: Boolean,
				default: true,
			},
		},

		// Data utöver de från mixin ovan:
		//data() {
		//	return {
		//		svgikonBurgare: SvgikonBurgare,
		//		svgikonBurgarePunkter: SvgikonBurgarePunkter,
		//		svgikonStang: SvgikonStang,
		//	};
		//},

		computed: {
			harText() {
				return this.$slots.default != undefined;
			},

			ikonPaStorlek() {
				// vpIkonPaStorlek === undefined => samma storlek som vpIkonAvStorlek:
				return this.vpIkonPaStorlek || this.vpIkonAvStorlek;
			},

			borderWidthValueAndUnit() {
				// https://stackoverflow.com/a/2868961/593779
				//var expr  = /(\d*\.?\d*)(.*)/,
				//	cases = [
				//		"1px",
				//		"1.px",
				//		"11.px",
				//		"11.1px",
				//		"11.11px",
				//		"1.11px",
				//		".11px",
				//		".1px",
				//		".px" // Invalid numeric value, but still preserves unit and can be handled as seen below
				//	];

				//for (var i = 0, l = cases.length; i < l; ++i) {
				//	var r = cases[i].match(expr);
				//	console.log(r, parseFloat(r[1], 10) || 0);
				//}
				//Results:
				//["1px", "1", "px"] 1
				//["1.px", "1.", "px"] 1
				//["11.px", "11.", "px"] 11
				//["11.1px", "11.1", "px"] 11.1
				//["11.11px", "11.11", "px"] 11.11
				//["1.11px", "1.11", "px"] 1.11
				//[".11px", ".11", "px"] 0.11
				//[".1px", ".1", "px"] 0.1
				//[".px", ".", "px"] 0

				const regEx  = /(\d*\.?\d*)(.*)/
				let delar = this.vpIkonAvStorlek.match(regEx);

				let borderAndelEnPa = 5;	//5;	//(this.vpDotted ? 6 : 5);

				//return parseFloat(delar[1]) || 0 ...;
				return (parseFloat(delar[1]) / borderAndelEnPa) + delar[2];
			},
		},

	},


	//------------------------------------------------------------------------------------------------

	// Metod för användning av komponenten som en plugin (Vue.use(..)) = global registrering:
	install(Vue, options) {
		Vue.component(this.component.name, this.component);
	},
};
